import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const ContactDetails = ({
  onSave, onNext,
  fullName, setFullName,
  jobRole, setJobRole,
  contactEmail, setContactEmail,
  contactPhone, setContactPhone,
}) => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm({
    defaultValues: { fullName: '', jobRole: '', contactEmail: '', contactPhone: '' }
  });

  useEffect(() => {
    setValue('fullName',      fullName      || '');
    setValue('jobRole',       jobRole       || '');
    setValue('contactEmail',  contactEmail  || '');
    setValue('contactPhone',  contactPhone  || '');
  }, [fullName, jobRole, contactEmail, contactPhone, setValue]);

  return (
    <div className="tab-content">
      <h1>Contact Details</h1>
      <p className="tab-description">
        Your point-of-contact details for order confirmations and deliveries. All fields are required.
      </p>
      <form onSubmit={handleSubmit(onSave)} className="business-form">

        <div className="form-group">
          <label htmlFor="fullName">Full name <span className="req">*</span></label>
          <input
            type="text"
            id="fullName"
            placeholder="e.g. Jane Smith"
            value={fullName}
            {...register('fullName', {
              required: 'Full name is required',
              onChange: (e) => setFullName(e.target.value)
            })}
          />
          {errors.fullName && <span className="error-text">{errors.fullName.message}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="jobRole">Job role <span className="req">*</span></label>
          <input
            type="text"
            id="jobRole"
            placeholder="e.g. Club Manager"
            value={jobRole}
            {...register('jobRole', {
              required: 'Job role is required',
              onChange: (e) => setJobRole(e.target.value)
            })}
          />
          {errors.jobRole && <span className="error-text">{errors.jobRole.message}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="contactEmail">Email address <span className="req">*</span></label>
          <input
            type="email"
            id="contactEmail"
            placeholder="you@example.com"
            value={contactEmail}
            {...register('contactEmail', {
              required: 'Email address is required',
              pattern: { value: /^\S+@\S+\.\S+$/, message: 'Enter a valid email' },
              onChange: (e) => setContactEmail(e.target.value)
            })}
          />
          {errors.contactEmail && <span className="error-text">{errors.contactEmail.message}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="contactPhone">Phone number <span className="req">*</span></label>
          <input
            type="tel"
            id="contactPhone"
            placeholder="e.g. 07700 900000"
            value={contactPhone}
            {...register('contactPhone', {
              required: 'Phone number is required',
              onChange: (e) => setContactPhone(e.target.value)
            })}
          />
          {errors.contactPhone && <span className="error-text">{errors.contactPhone.message}</span>}
        </div>

        <div className="form-navigation">
          <button type="submit">Save</button>
          <button type="button" onClick={onNext}>Next →</button>
        </div>
      </form>
    </div>
  );
};

export default ContactDetails;
